import { Fragment } from 'react';
import { Badge, Button, Col, Form, Row, Table } from 'react-bootstrap';

import type { RelatorioCivelStepProps } from './relatorio-civel-step-props';
import type { AcordoExtrajudicialItem } from '../relatorio-civel-page.models';

export default function Step11AcordosExtrajudiciais(props: RelatorioCivelStepProps) {
  const {
    apenasLetras,
    RELATORIO_CORES,
    quantidadeLinhas,
    setQuantidadeLinhas,
    formData,
    isViewMode,

    novoNomeParteAcordo,
    setNovoNomeParteAcordo,
    anexoAcordoInputRef,
    handleFileChangeAcordo,
    adicionarAcordoExtrajudicial,
    adicionarMultiplasLinhasAcordosExtrajudiciais,

    editandoAcordoExtrajudicial,
    valorEdicaoNomeParteAcordo,
    setValorEdicaoNomeParteAcordo,
    anexoAcordoEdicaoInputRef,
    handleFileChangeAcordoEdicao,
    valorEdicaoAnexoAcordo,
    salvarEdicaoAcordoExtrajudicial,
    cancelarEdicaoAcordoExtrajudicial,
    iniciarEdicaoAcordoExtrajudicial,
    removerAcordoExtrajudicial,
  } = props;

  return (
    <Fragment>
      {!isViewMode && (
        <>
          {/* Linha 1: legendas */}
          <Row className="mb-1">
            <Col md={6}>
              <Form.Label className="fw-bold mb-0">Nome da Parte</Form.Label>
            </Col>
            <Col md={5}>
              <Form.Label className="fw-bold mb-0">Anexo</Form.Label>
            </Col>
            <Col md={1} />
          </Row>
          {/* Linha 2: inputs e botão Adicionar */}
          <Row className="mb-1 align-items-center">
            <Col md={6}>
              <Form.Control
                type="text"
                placeholder="Ex: João Silva"
                value={novoNomeParteAcordo}
                onChange={(e) => setNovoNomeParteAcordo(apenasLetras(e.target.value))}
                onKeyPress={(e) => {
                  if (!/[a-zA-ZÀ-ÿ\\s]/.test(e.key) && e.key !== 'Enter' && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                    e.preventDefault();
                  }
                }}
              />
            </Col>
            <Col md={5}>
              <Form.Control
                ref={anexoAcordoInputRef}
                type="file"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                onChange={handleFileChangeAcordo}
              />
            </Col>
            <Col md={1}>
              <Button variant="primary" onClick={adicionarAcordoExtrajudicial} style={{ borderRadius: '8px' }} className="w-100">
                <i className="bi bi-plus-lg me-2"></i>
                Adicionar
              </Button>
            </Col>
          </Row>
          {/* Linha 3: anotação do anexo */}
          <Row className="mb-3">
            <Col md={6} />
            <Col md={5}>
              <Form.Text className="text-muted">Arquivo de até 10MB (PDF, DOC, DOCX, JPG, JPEG, PNG)</Form.Text>
            </Col>
            <Col md={1} />
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <div className="d-flex align-items-center gap-2">
                <span className="text-muted">Adicionar</span>
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() =>
                setQuantidadeLinhas((prev) => ({
                  ...prev,
                  acordosExtrajudiciais: Math.max(1, prev.acordosExtrajudiciais - 1),
                }))
              }
              style={{ borderRadius: '8px', width: '32px', height: '32px', padding: 0 }}
            >
              <i className="bi bi-dash">-</i>
            </Button>
            <Form.Control
              type="number"
              min="1"
              max="50"
              value={quantidadeLinhas.acordosExtrajudiciais}
              onChange={(e) =>
                setQuantidadeLinhas((prev) => ({
                  ...prev,
                  acordosExtrajudiciais: Math.max(1, parseInt(e.target.value) || 1),
                }))
              }
              style={{ width: '60px', textAlign: 'center', borderRadius: '8px' }}
              size="sm"
            />
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() =>
                setQuantidadeLinhas((prev) => ({
                  ...prev,
                  acordosExtrajudiciais: Math.min(50, prev.acordosExtrajudiciais + 1),
                }))
              }
              style={{ borderRadius: '8px', width: '32px', height: '32px', padding: 0 }}
            >
              <i className="bi bi-plus">+</i>
            </Button>
            <Button variant="outline-primary" size="sm" onClick={adicionarMultiplasLinhasAcordosExtrajudiciais} style={{ borderRadius: '8px' }}>
              <i className="bi bi-plus-lg me-1"></i>
              Adicionar {quantidadeLinhas.acordosExtrajudiciais} linha{quantidadeLinhas.acordosExtrajudiciais > 1 ? 's' : ''}
            </Button>
              </div>
            </Col>
            <Col md={6} className="d-flex align-items-center justify-content-end">
              <h5 className="mb-0" style={{ color: RELATORIO_CORES.PRIMARIA }}>
                <small className="text-muted">Total de Itens:</small> {formData.acordosExtrajudiciais.itens.length}
              </h5>
            </Col>
          </Row>
        </>
      )}

      <Table bordered hover>
        <thead className="table-light">
          <tr>
            <th style={{ width: '5%' }}>#</th>
            <th style={{ width: '35%' }}>Nome da Parte</th>
            <th style={{ width: '35%' }}>Anexo</th>
            <th style={{ width: '25%' }}>Ações</th>
          </tr>
        </thead>
        <tbody>
          {formData.acordosExtrajudiciais.itens.length === 0 ? (
            <tr>
              <td colSpan={4} className="text-center text-muted">
                Nenhum acordo extrajudicial adicionado ainda
              </td>
            </tr>
          ) : (
            formData.acordosExtrajudiciais.itens.map((item: AcordoExtrajudicialItem, index: number) => {
              const estaEditando = editandoAcordoExtrajudicial === item.id;

              return (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>
                    {estaEditando ? (
                      <Form.Control
                        type="text"
                        size="sm"
                        placeholder="Ex: João Silva"
                        value={valorEdicaoNomeParteAcordo}
                        onChange={(e) => setValorEdicaoNomeParteAcordo(apenasLetras(e.target.value))}
                        style={{ borderRadius: '8px' }}
                      />
                    ) : (
                      item.nomeParte
                    )}
                  </td>
                  <td>
                    {estaEditando ? (
                      <div>
                        <Form.Control
                          type="file"
                          size="sm"
                          ref={anexoAcordoEdicaoInputRef}
                          onChange={handleFileChangeAcordoEdicao}
                          accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                          style={{ borderRadius: '8px' }}
                        />
                        {valorEdicaoAnexoAcordo && (
                          <small className="text-muted d-block mt-1">
                            {valorEdicaoAnexoAcordo.name} ({(valorEdicaoAnexoAcordo.size / 1024 / 1024).toFixed(2)} MB)
                          </small>
                        )}
                        {!valorEdicaoAnexoAcordo && item.anexoNome && (
                          <small className="text-muted d-block mt-1">Arquivo atual: {item.anexoNome}</small>
                        )}
                      </div>
                    ) : item.anexoNome ? (
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-file-earmark"></i>
                        <span>{item.anexoNome}</span>
                        {item.anexo && (
                          <Badge style={{ backgroundColor: RELATORIO_CORES.PRIMARIA }}>
                            {(item.anexo.size / 1024 / 1024).toFixed(2)} MB
                          </Badge>
                        )}
                      </div>
                    ) : (
                      <span className="text-muted">Sem anexo</span>
                    )}
                  </td>
                  <td>
                    {estaEditando ? (
                      <div className="d-flex gap-1">
                        <Button style={{ width: '80px', height: '40px' }} variant="success" size="sm" onClick={() => salvarEdicaoAcordoExtrajudicial(item.id)} title="Salvar">
                          <i className="bi bi-check-lg"> Salvar</i>
                        </Button>
                        <Button style={{ width: '80px', height: '40px' }} variant="secondary" size="sm" onClick={cancelarEdicaoAcordoExtrajudicial} title="Cancelar">
                          <i className="bi bi-x-lg"> Cancelar</i>
                        </Button>
                      </div>
                    ) : (
                      <div className="d-flex gap-1">
                        <Button style={{ width: '80px', height: '40px' }} variant="outline-primary" size="sm" onClick={() => iniciarEdicaoAcordoExtrajudicial(item)} title="Editar">
                          <i className="bi bi-pencil"> Editar</i>
                        </Button>
                        <Button variant="danger" size="sm" onClick={() => removerAcordoExtrajudicial(item.id)} style={{ width: '80px', height: '40px' }} title="Excluir">
                          <i className="bi bi-trash"> Excluir</i>
                        </Button>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </Table>
    </Fragment>
  );
}

